<template>
  <div class="drug-box">
    <div class="img-item">
      <img src="http://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/schoolbadge/bg.png" alt="">
    </div>
    <div class="img-item-2">
      <img @click="goApp" src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/schoolbadge/btn.png" alt="">
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {

    }
  },
  methods: {
    goApp () {
      if (window._czc) {
        window._czc.push(['_trackEvent', '电子校徽短信推广页', '推广查看电子校徽', '推广查看电子校徽', '', '030'])
      }
      window.location.href = 'bjqd://'
      setTimeout(function () {
        window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.bsit.coband'
      }, 1200)
    }
  }
}
</script>
<style lang="scss" scoped>
.drug-box {
  min-height: 100vh;
  font-size: 0;
}
.img-item {
  img {
    width: 100%;
  }
}
.img-item-2 {
  position: absolute;
  bottom: 18px;
  padding: 0 20px;
  img {
    width: 100%;
  }
}
</style>
